import React, { useEffect, useState } from 'react';
import { Card } from '../../shared/components';
import { api } from '../../utils/api';
import FlashcardViewer from './FlashcardViewer';
import './Flashcards.css';

export default function Flashcards() {
  const [topics, setTopics] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api
      .get('/api/topics')
      .then(setTopics)
      .catch(() => setError('Unable to load topics right now.'));
  }, []);

  if (selectedTopic) {
    return <FlashcardViewer topic={selectedTopic} onExit={() => setSelectedTopic(null)} />;
  }

  return (
    <div className="flashcards-page">
      <h1>Flashcards</h1>
      <p className="flashcards-intro">Choose a topic to review key terms and definitions.</p>
      {error && <p className="flashcards-error">{error}</p>}

      <div className="flashcards-topic-list">
        {topics.map((topic) => (
          <Card key={topic.id} className="flashcards-topic-card" onClick={() => setSelectedTopic(topic)}>
            <h2>{topic.name}</h2>
            <p>{topic.description}</p>
          </Card>
        ))}
      </div>
    </div>
  );
}
